function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSameSex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-336.1525,24.792h-2.312a4.3343,4.3343,0,0,0-4.328,4.123l-.005.21v1.162h10.978V29.125A4.3331,4.3331,0,0,0-336.1525,24.792Zm2.961-4.298a6.9368,6.9368,0,0,1,6.857,6.78l.004.242v2.768h12.855a5.7778,5.7778,0,0,1,5.774,5.5559l.004.2221v5.064a23.0853,23.0853,0,0,0-4.333-.41,23.0668,23.0668,0,0,0-17.979,8.589,7.6361,7.6361,0,0,0-5.855-2.811,8.1751,8.1751,0,0,0-7.82,7.134q-8.241-.201-16.483-.874a5.7777,5.7777,0,0,1-5.303-5.528l-.005-.231V36.062a5.7785,5.7785,0,0,1,5.556-5.774l.222-.004h11.411V27.516a6.95,6.95,0,0,1,6.625-7.018l.236-.004Zm-3.395,30.3329c1.995,0,3.611,1.9411,3.611,4.3341s-1.616,4.333-3.611,4.333-3.611-1.94-3.611-4.333S-338.58,50.8269-336.5865,50.8269Zm29.743,6.4931a2.0262,2.0262,0,0,1,2.716-.343,1.7393,1.7393,0,0,1,.366,2.544l-8.804,10.825a1.9736,1.9736,0,0,1-1.522.704,1.9778,1.9778,0,0,1-1.522-.686l-4.681-5.611a1.7314,1.7314,0,0,1,.337-2.535,2.0179,2.0179,0,0,1,2.707.316l3.14,3.807,7.282-9.021Zm-57.187-.715a178.5755,178.5755,0,0,0,21.183,2.69,7.8729,7.8729,0,0,0,6.983,4.5319q.366,0,.723-.0349v.0349a23.0345,23.0345,0,0,0,1.674,8.6521l-.801.007-2.318.008q-14.343,0-24.034-2.37a2.8878,2.8878,0,0,1-2.157-2.299l-.028-.188Zm52-7.222a14.4444,14.4444,0,0,0-14.445,14.4439A14.4447,14.4447,0,0,0-312.03,78.272a14.4407,14.4407,0,0,0,10.213-4.231,14.4448,14.4448,0,0,0,4.231-10.2141A14.4442,14.4442,0,0,0-312.03,49.383Zm0-4.333a18.7773,18.7773,0,0,1,13.278,5.5,18.7773,18.7773,0,0,1,5.5,13.2769A18.7784,18.7784,0,0,1-312.03,82.605a18.7778,18.7778,0,0,1-18.778-18.7781A18.7775,18.7775,0,0,1-312.03,45.05Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-333.5193,139.1668l1.091,1.102,1.092-1.102a5.2662,5.2662,0,0,1,7.481,0,5.3963,5.3963,0,0,1,0,7.546l-7.8551,7.932a1.0045,1.0045,0,0,1-.7179.296,1.003,1.003,0,0,1-.7171-.296l-7.8559-7.932a5.3982,5.3982,0,0,1,0-7.546A5.2674,5.2674,0,0,1-333.5193,139.1668Zm22.758,4.219a7.2215,7.2215,0,0,1,7.222,7.222,7.2215,7.2215,0,0,1-7.222,7.222,7.2215,7.2215,0,0,1-7.222-7.222A7.2215,7.2215,0,0,1-310.7613,143.3858Zm-43.333,0a7.2215,7.2215,0,0,1,7.222,7.222,7.2215,7.2215,0,0,1-7.222,7.222,7.2215,7.2215,0,0,1-7.222-7.222A7.2215,7.2215,0,0,1-354.0943,143.3858Zm46.222,17.333a8.6672,8.6672,0,0,1,8.667,8.667v18.777h-7.223v13a4.3333,4.3333,0,0,1-4.333,4.334,4.3332,4.3332,0,0,1-4.333-4.334v-13h-7.222v-18.777a8.6663,8.6663,0,0,1,8.6659-8.667Zm-42.374,0a2.1682,2.1682,0,0,1,2.059,1.49l8.5369,25.954h-10.112l.0011,13a4.3333,4.3333,0,0,1-4.333,4.334,4.3341,4.3341,0,0,1-4.334-4.334v-13h-10.111l8.538-25.954a2.166,2.166,0,0,1,2.058-1.49Z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-209.1816,27.532h-2.312a4.3343,4.3343,0,0,0-4.328,4.123l-.005.21v1.162h10.978V31.865A4.3331,4.3331,0,0,0-209.1816,27.532Zm2.961-4.298a6.9368,6.9368,0,0,1,6.857,6.78l.004.242v2.768h12.855a5.7785,5.7785,0,0,1,5.774,5.556l.004.222v5.064a23.0853,23.0853,0,0,0-4.333-.41,23.0668,23.0668,0,0,0-17.979,8.589,7.6364,7.6364,0,0,0-5.855-2.811,8.1751,8.1751,0,0,0-7.82,7.134q-8.241-.201-16.483-.874a5.7777,5.7777,0,0,1-5.303-5.528l-.005-.231V38.802a5.7787,5.7787,0,0,1,5.557-5.774l.221-.004h11.411V30.256a6.95,6.95,0,0,1,6.626-7.018l.235-.004Zm-3.395,30.333c1.995,0,3.611,1.941,3.611,4.334s-1.616,4.333-3.611,4.333-3.611-1.94-3.611-4.333S-211.61,53.567-209.6156,53.567Zm24.556,3.612A2.0158,2.0158,0,0,1-182.9,58.7l.006.129v8.254a1.9619,1.9619,0,0,1-2.166,1.651,2.0148,2.0148,0,0,1-2.16-1.522l-.007-.129V58.829A1.9623,1.9623,0,0,1-185.06,57.179Zm-52,2.166a178.5755,178.5755,0,0,0,21.183,2.69,7.873,7.873,0,0,0,6.983,4.532q.366,0,.723-.035v.035a23.0344,23.0344,0,0,0,1.674,8.652l-.801.007-2.318.008q-14.343,0-24.034-2.37a2.8878,2.8878,0,0,1-2.157-2.299l-.028-.188Zm52,12.278a2.1665,2.1665,0,0,1,2.166,2.167,2.1663,2.1663,0,0,1-2.166,2.166,2.1665,2.1665,0,0,1-2.167-2.166A2.1667,2.1667,0,0,1-185.06,71.623Zm0-19.5a14.4445,14.4445,0,0,0-14.445,14.444A14.4447,14.4447,0,0,0-185.06,81.012a14.4448,14.4448,0,0,0,10.214-4.231,14.448,14.448,0,0,0,4.23-10.214A14.4443,14.4443,0,0,0-185.06,52.123Zm0-4.333a18.7773,18.7773,0,0,1,13.278,5.5,18.7774,18.7774,0,0,1,5.5,13.277A18.7784,18.7784,0,0,1-185.06,85.345a18.7777,18.7777,0,0,1-18.778-18.778A18.7775,18.7775,0,0,1-185.06,47.79Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 599.3191,
    cy: 548.7021,
    r: 60,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-81.76,27.7849h-2.312a4.3341,4.3341,0,0,0-4.328,4.123l-.005.21V33.28h10.978v-1.162A4.3331,4.3331,0,0,0-81.76,27.7849Zm2.961-4.298a6.9368,6.9368,0,0,1,6.857,6.78l.004.242v2.768h12.855a5.7785,5.7785,0,0,1,5.774,5.5559l.004.2221v5.064a23.0853,23.0853,0,0,0-4.333-.41,23.0668,23.0668,0,0,0-17.979,8.589,7.6362,7.6362,0,0,0-5.8551-2.811,8.1751,8.1751,0,0,0-7.82,7.134q-8.241-.201-16.483-.8741a5.7776,5.7776,0,0,1-5.303-5.5279l-.005-.231V39.0549a5.7786,5.7786,0,0,1,5.557-5.774l.221-.004h11.4109v-2.768a6.95,6.95,0,0,1,6.6261-7.018l.235-.004ZM-82.194,53.82c1.9949,0,3.611,1.9411,3.611,4.3341s-1.6161,4.333-3.611,4.333-3.611-1.94-3.611-4.333S-84.188,53.82-82.194,53.82Zm-27.444,5.7781a178.5755,178.5755,0,0,0,21.183,2.69A7.8728,7.8728,0,0,0-81.4721,66.82q.3662,0,.7231-.0349V66.82a23.0345,23.0345,0,0,0,1.674,8.6521l-.8011.007-2.3179.008q-14.3431,0-24.034-2.37a2.8877,2.8877,0,0,1-2.157-2.299l-.028-.188Zm52-7.222a14.3791,14.3791,0,0,0-7.992,2.41l18.454,21.9931A14.4454,14.4454,0,0,0-43.194,66.82,14.4442,14.4442,0,0,0-57.638,52.3759Zm-11.203,5.326A14.38,14.38,0,0,0-72.083,66.82,14.4447,14.4447,0,0,0-57.638,81.2649a14.44,14.44,0,0,0,7.034-1.829Zm11.203-9.659a18.7773,18.7773,0,0,1,13.278,5.5A18.7773,18.7773,0,0,1-38.86,66.82,18.7784,18.7784,0,0,1-57.638,85.5979,18.7777,18.7777,0,0,1-76.416,66.82,18.7774,18.7774,0,0,1-57.638,48.0429Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.7363,18.59a6.5,6.5,0,1,1-6.579,6.5A6.54,6.54,0,0,1,68.7363,18.59Zm-34.911,0a6.5,6.5,0,1,1-6.5,6.5A6.5,6.5,0,0,1,33.8253,18.59Zm46.1119,17.882.083.1621,8.656,18.3389.0981.233a2.8893,2.8893,0,0,1-1.34,3.543l-.162.081-1.3771.634a2.8884,2.8884,0,0,1-3.739-1.229l-.083-.161-4.5619-9.666v37.305a3.6555,3.6555,0,0,1-7.311,0V64.09H67.2762v21.623a3.6555,3.6555,0,0,1-7.3109,0V48.4047l-4.5641,9.669a2.8875,2.8875,0,0,1-3.8209,1.39l-.406-.187-.348.164a2.89,2.89,0,0,1-3.76-1.24l-.0789-.157-4.495-9.639.0009,37.352a3.611,3.611,0,1,1-7.222,0V64.09H32.3823v21.667a3.6111,3.6111,0,0,1-7.2221,0l-.0009-37.352-4.4941,9.639a2.8886,2.8886,0,0,1-3.8389,1.397l-1.309-.61a2.89,2.89,0,0,1-1.3971-3.84l8.546-18.327a2.888,2.888,0,0,1,3.839-1.397l.114.0521a2.18,2.18,0,0,1,.708-.1181h13a2.1721,2.1721,0,0,1,.7061.1181l.114-.0521a2.8878,2.8878,0,0,1,3.76,1.24l.079.157,6.188,13.273,6.281-13.3029a2.889,2.889,0,0,1,3.8209-1.3911l.16.072a2.162,2.162,0,0,1,.6961-.114H75.3442a2.1655,2.1655,0,0,1,.696.114l.1591-.072A2.8894,2.8894,0,0,1,79.9372,36.4717Z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1122.5957,
    y: -275.0213,
    width: 1440,
    height: 1024,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.4043,
    y: 17.9787,
    width: 76,
    height: 72,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-57.3936,198.3784a10.1112,10.1112,0,0,1-10.111-10.1111,10.1105,10.1105,0,0,1,10.111-10.1109,10.1105,10.1105,0,0,1,10.111,10.1109,10.111,10.111,0,0,1-2.961,7.1491A10.1123,10.1123,0,0,1-57.3936,198.3784Zm0-24.5561a14.4445,14.4445,0,0,0-14.444,14.445,14.4442,14.4442,0,0,0,14.444,14.444,14.4444,14.4444,0,0,0,14.445-14.444,14.4446,14.4446,0,0,0-4.231-10.2139A14.4445,14.4445,0,0,0-57.3936,173.8223Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-53.4332,183.5964l-4.855,5.413-2.093-2.284a1.4517,1.4517,0,0,0-1.805-.19.9743.9743,0,0,0-.224,1.521l3.1209,3.367a1.3853,1.3853,0,0,0,1.0141.411,1.3841,1.3841,0,0,0,1.015-.422l5.8689-6.495a.98.98,0,0,0-.2439-1.527,1.46,1.46,0,0,0-1.811.206Z",
    style: {
      fill: "none"
    }
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "same-sex") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#f)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#g)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#h)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#h)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.8482,
    y: 13.5897,
    width: 85.105,
    height: 80.778,
    style: {
      fill: "#f1ce3b"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSameSex);
export default __webpack_public_path__ + "static/media/same-sex.f67426e0e023de964e28c6425cdacfb4.svg";
export { ForwardRef as ReactComponent };